import Fuse from 'fuse.js';

export function search<T>(
    query: string,
    items: T[],
    keys: (
        | string
        | {
              name: string;
              threshold?: number;
              getFn?: (item: T) => string;
          }
    )[]
): T[] {
    if (!query.trim()) return items;

    const options = {
        includeScore: true,
        shouldSort: false,
        threshold: 0.3,
        ignoreDiacritics: true,
        keys
    };
    const fuse = new Fuse(items, options);

    return fuse.search(query).map((result) => result.item);
}
